export default __webpack_public_path__ + "static/media/ge.2bec9c7c.svg";